import { ChangeEvent } from 'react';
import tw from 'twin.macro';

const SwitchContainer = tw.div`h-[20px] w-[38px] min-h-[20px] min-w-[38px] rounded-full relative`;
const SwitchButton = tw.div`h-[18px] w-[18px] bg-white rounded-full transition-all duration-100 ease-in-out left-[1px] absolute top-1/2 -translate-y-1/2`;
const Input = tw.input`top-0 left-0 bottom-0 right-0 opacity-0 w-full h-full cursor-pointer`;

export const Switch = ({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (e: boolean) => void;
}) => {
  return (
    <SwitchContainer tw='' css={[checked ? tw`bg-accent` : tw`bg-muted4`]}>
      <SwitchButton css={[checked ? tw`translate-x-[18px]` : tw`shadow`]} />
      <Input
        type='checkbox'
        checked={checked}
        onChange={(e) => {
          const {
            target: { checked },
          } = e as ChangeEvent<HTMLInputElement>;
          onChange(checked);
        }}
      />
    </SwitchContainer>
  );
};
